class GraphService {
  private baseUrl = 'https://graph.microsoft.com/v1.0';
  private photoCache = new Map<string, string>(); // Cache photos by user ID

  async getUserPhoto(accessToken: string, userId?: string): Promise<string | null> {
    try {
      const cacheKey = userId || 'current_user';
      
      // Check cache first
      if (this.photoCache.has(cacheKey)) {
        const cachedUrl = this.photoCache.get(cacheKey);
        return cachedUrl;
      }
      
      // Get the actual photo data directly
      const photoResponse = await fetch(`${this.baseUrl}/me/photo/$value`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Accept': 'image/*'
        }
      });

      
      if (!photoResponse.ok) {
        if (photoResponse.status === 404) {
          // User has no profile photo - this is normal
        } else {
          console.error('Error fetching photo:', photoResponse.statusText);
        }
        return null;
      }

      const blob = await photoResponse.blob();
      
      // Create blob URL and cache it
      const blobUrl = URL.createObjectURL(blob);
      this.photoCache.set(cacheKey, blobUrl);
      return blobUrl;
    } catch (error) {
      console.error('Error fetching profile photo from Graph API:', error);
      return null;
    }
  }

  // Clean up blob URLs when no longer needed
  clearPhotoCache() {
    this.photoCache.forEach(url => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
    this.photoCache.clear();
  }
}

export const graphService = new GraphService();